<template>
  <div class="absolute top-0 h-1/2 w-full overflow-hidden">
    <img
      class="absolute h-full w-full object-cover"
      src="/images/wrapped/bgpage04top.png"
      alt=""
    />
    <img
      class="absolute bottom-[35%] left-[20%] max-h-[89px] max-w-[48px]"
      src="/images/wrapped/arrowright.png"
      alt=""
    />
    <div class="absolute h-full w-full bg-[#61E5FF] opacity-20"></div>

    <div class="absolute bottom-0 h-1 w-full bg-[#61E5FF]"></div>

    <div class="absolute bottom-[17%] left-[10%] z-10">
      <WrappedShadowContainer
        class="bg-gradient-to-b from-white to-[#61E5FF] px-2 py-2"
      >
        <WrappedTextContainer
          class="whitespace-nowrap text-[26px] text-[#FFE617]"
        >
          how it started
        </WrappedTextContainer>
      </WrappedShadowContainer>
    </div>
  </div>
  <div class="absolute top-1/2 h-1/2 w-full overflow-hidden">
    <img
      class="absolute h-full w-full object-cover"
      src="/images/wrapped/bgpage04bottom.png"
      alt=""
    />
    <img
      class="absolute bottom-[20%] left-[53%] max-h-[89px] max-w-[48px]"
      src="/images/wrapped/arrowleft.png"
      alt=""
    />

    <div class="absolute h-full w-full bg-[#61E5FF] opacity-20"></div>

    <div class="absolute bottom-[15%] left-[10%] z-10">
      <WrappedShadowContainer
        class="bg-gradient-to-b from-white to-[#61E5FF] px-2 py-2"
      >
        <WrappedTextContainer
          class="whitespace-nowrap text-[26px] text-[#FFE617]"
        >
          how it's going
        </WrappedTextContainer>
      </WrappedShadowContainer>
    </div>
  </div>
  <img
    class="absolute left-4 top-8 h-auto max-h-[21px] w-auto max-w-[21px]"
    src="/images/wrapped/ddccircularlogo.png"
    alt=""
  />
  <img class="absolute top-0" src="/images/wrapped/gradient.png" alt="" />
</template>
